import * as React from 'react';

import { Col, Cols, Format } from 'core/ui';
import { SalesOrderType, DeliveryStatus } from 'core/api';
import * as Images from 'pos/Images';
import * as UI from 'core/ui';
import { SalesOrderModel } from './SalesOrderModel';
import { SvgIcon } from 'core/ui-next';

export default function Orders({ orders, selectedOrderId: selectedOrderId, selectOrder }: { orders: SalesOrderModel[], selectedOrderId: number, selectOrder: (order: SalesOrderModel) => void }): React.ReactNode {
	return <>
		{orders.map(order => <OrderCard key={order.Id} order={order} selected={order.Id === selectedOrderId} onSelected={selectOrder} />)}
	</>;
}
function OrderCard({ order, selected, onSelected }: { order: SalesOrderModel, selected: boolean, onSelected: (order: SalesOrderModel) => void }): React.ReactNode {



	const statusToStyle: { [key in DeliveryStatus]: { className: string, image: React.ReactNode }
	} = {
		[DeliveryStatus.New]: { className: 'info', image: <SvgIcon color='#61AAED' width={'20px'} height={'20px'} src={Images.TakeOutNew} /> },
		[DeliveryStatus.Accepted]: { className: 'success', image: <SvgIcon color='#75CA8D' width={'20px'} height={'20px'} src={Images.TakeOutAccepted} /> },
		[DeliveryStatus.Rejected]: { className: 'danger2', image: <SvgIcon color="#FF8A95" width={'20px'} height={'20px'} src={Images.TakeOutRejected} /> },
		[DeliveryStatus.Preparing]: { className: 'warning2', image: <SvgIcon color="#FFBA7B" width={'20px'} height={'20px'} src={Images.TakeOutPreparing} /> },
		[DeliveryStatus.Prepared]: { className: 'warning2', image: <SvgIcon color="#FFBA7B" width={'20px'} height={'20px'} src={Images.TakeOutPrepared} /> },
		[DeliveryStatus.Delivering]: { className: 'primary2', image: <SvgIcon color="#C291F3" width={'20px'} height={'20px'} src={Images.TakeOutDelivering} /> },
		[DeliveryStatus.Delivered]: { className: 'primary2', image: <SvgIcon color="#C291F3" width={'20px'} height={'20px'} src={Images.TakeOutDelivered} /> },
	};

	return <Cols className={`m-sm p-xs border panel-horizontal ${statusToStyle[order.DeliveryStatus].className} ${selected ? 'selected' : ''}`} onClick={_ => onSelected(order)}>
		<Col width='26px' style={{ marginTop: 2 }}>
			{statusToStyle[order.DeliveryStatus].image}
		</Col>
		<Col width='*'>
			<div className='text-18 font-bold'>{order.SerialNumber}</div>
			<div className='text-14 text-muted m-t-xs'>{order.Customer.FiscalName} <span className='m-l-sm m-r-xxs fa fa-phone font-trans'></span> <strong>{order.CustomerPhone}</strong></div>
			<div className='text-14 text-muted m-t-xs'>{order.Type === SalesOrderType.Delivery ? order.DeliveryAddressSummary : <>&nbsp;</>}</div>
		</Col>
		<Col className='text-right'>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{order.Type === SalesOrderType.Delivery
					? <> <span className='text-18 text-muted m-r-sm'>{order.DeliveryPerson}</span> <SvgIcon className='m-t-n-xs m-r-xs' color="#4C566A" marginRight={'5px'} width={'22px'} height={'22px'} src={Images.DeliveryOutline} /> </>
					: <SvgIcon className='m-t-n-xs m-r-xs' color="#4C566A" marginRight={'5px'} width={'22px'} height={'22px'} src={Images.TakeAwayOutline} />
				}
				<span className='text-26 font-bold'>{Format.asDeliveryDate(order.DeliveryDate!)}</span>
			</div>
			<div className='text-18 text-muted font-bold m-t-sm' style={{ marginTop: '13px' /* TODO: esto se puede hacer mejor con flex seguro */ }}>
				{order.PendingAmount === 0 ?
					<SvgIcon className='m-t-n-xs m-r-xs' color="#D6AF28" width={'16px'} height={'16px'} src={Images.TakeOutPaid} />
					: null}
				{order.IsInvoiced ?
					<SvgIcon className='m-t-n-xs m-r-xs' color="#75CA8D" width={'16px'} height={'16px'} src={Images.TakeOutInvoiced} />
					: null}
				{UI.Format.asMoney(order.NetAmount)}
			</div>
		</Col>
	</Cols>;
}